export * from './lib/shared-util-strings.module';
export * from './lib/uniqId';
export * from './lib/normalizer';
export * from './lib/uniqId';
export * from './lib/replaceAccentsFromWord';
export * from './lib/userNameAbbreviation';
export * from './lib/trimFilenameToLength';
export * from './lib/sanitizeStringForRegex';
